module.exports = __webpack_public_path__ + "img/logo_femp.d8374e3b.jpg";